import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {GROUP_MUTE} from 'session/constants.js';

class GroupMuteEvent extends SessionEvent {
    constructor(groupNumber, mute) {
        super();
        this.groupNumber = groupNumber;
        this.mute = mute;
    }

    getValue() {
        return this.mute ? 0 : 1;
    }

    isSkippable() {
        return false;
    }

    executeEvent(sequencerEngine) {
        this.subSequence.groups.groups[this.groupNumber].mute(this.mute);
    }

    getType() {
        return GROUP_MUTE;
    }

    getJson() {
        return {
            ... super.getJson(),
            groupNumber: this.groupNumber,
            mute: this.mute,
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.groupNumber = json.groupNumber;
        this.mute = json.mute;
        return this;
    }
}

export default GroupMuteEvent;
